import React from "react";
import {Route, Switch} from "react-router-dom";
import AppearanceScreen from "./AppearanceScreen";
import AuditLogScreen from "./AuditLogScreen";
import { ServiceAccountsTab } from "./ServiceAccountsTab";
import { useFlag } from "../../lib/flags";

export function AdminScreen() {
  const themeFlag = useFlag('ADMIN_APPEARANCE');
  const defaultScreen = themeFlag.enabled ? AppearanceScreen : AuditLogScreen;

  return (
    <Switch>
      <Route path="/admin" exact component={defaultScreen} />
      {themeFlag.enabled && <Route path="/admin/appearance" component={AppearanceScreen} />}
      <Route path="/admin/auditlog" component={AuditLogScreen} />
      <Route path="/admin/service-accounts" component={ServiceAccountsTab} />
    </Switch>
  );
}